export default "__VITE_ASSET__EnQjG4E1__"